import { ExcelDownloadReasonModal as StockLedgerExcelDownloadReasonModal } from '@/pages/inventory/stockLedger/components/ExcelDownloadReasonModal'
import type { DailyCloseProductDownloadReason } from '@/services/inventory/dailyCloseProduct/types'

interface Props {
  open: boolean
  onConfirm: (reason: DailyCloseProductDownloadReason) => void
  onCancel: () => void
}

/** ST10·RP13과 같은 다운로드 사유 모달을 RP12 요청 타입에 연결한다. 1.0 RP02 도 공통 ToolBar 의 RemarkPop 을 거친다. */
export function ExcelDownloadReasonModal(props: Readonly<Props>) {
  return <StockLedgerExcelDownloadReasonModal {...props} />
}
